export enum ErrorMessageConstants {
  NO_FILE_SELECTED = "Please select a file.",
  INVALID_FILE_FORMAT = "Only .pdf, .png, .jpg, or .jpeg files are allowed.",
  NO_IMAGE_CAPTURED = "No image was captured. Please try again.",
  FUTURE_DATE_SELECTION = "Invalid time. You can’t select a time in the future.",
  SAME_DATE_SELECTION = "The selected times must be different.",
  FROM_DATE_BIGGER_THAN_TO_DATE = "‘From’ date should be earlier than ‘To’ date.",
  PAGINATION_NO_ENTRIES_FOUND = "No more records found.",
  NEW_AND_CONFIRM_PASSWORD_DO_NOT_MATCH = "New password and confirm password do not match.",
  ERROR_LOGGING_IN = "There was a problem logging in. Please try again.",
  INVALID_INPUT_STRING = "Only letters allowed. No spaces at the beginning or end.",
  NO_DATA_FOUND_FOR_PROVIDED_SELECTION = "No data found for the selected options.",
  KEY_FOB_RANGE_ERROR = "The ‘To’ range should be greater than the ‘From’ range.",
  KEY_FOB_TOKEN_REQUIRED = "Please enter a KeyFob token.",
  KEY_FOB_ID_REQUIRED = "KeyFob ID is required.",
  SELECT_CUSTOMER_LOCATION_FILTER = "Please select both Customer and Location."
}
